module.exports = __webpack_public_path__ + "img/set_email@3x.f73c437e.png";